module.exports = __webpack_public_path__ + "static/media/lete.9f537f4c.m4a";